import { stringToSVG } from '../../../utilities';

const svg = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g class="svg-stroke" stroke="currentColor">
    <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H12H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M12 11V14" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
  </g>
  <g class="svg-fill" fill="currentColor">
    <circle cx="12" cy="17" r="1"></circle>
  </g>
</svg>
`;

export default stringToSVG(svg);